import { ErrorEnvelopeSchema, type ErrorCode } from "@safeplate/contracts";

export class ApiError extends Error {
  readonly code: ErrorCode | "network";
  readonly requestId: string | undefined;
  readonly status: number;

  constructor(input: {
    code: ErrorCode | "network";
    message: string;
    requestId?: string;
    status: number;
  }) {
    super(input.message);
    this.name = "ApiError";
    this.code = input.code;
    this.requestId = input.requestId;
    this.status = input.status;
  }
}

export function apiErrorFromResponse(
  response: Response,
  body: unknown,
): ApiError {
  const envelope = ErrorEnvelopeSchema.safeParse(body);

  if (envelope.success) {
    return new ApiError({
      code: envelope.data.error.code,
      message: envelope.data.error.message,
      requestId: envelope.data.error.request_id,
      status: response.status,
    });
  }

  return new ApiError({
    code: response.status === 401 ? "unauthenticated" : "internal",
    message:
      response.status === 401
        ? "Please sign in to continue."
        : "SafePlate could not complete that request.",
    status: response.status,
  });
}

export function networkError(error: unknown): ApiError {
  return new ApiError({
    code: "network",
    message:
      error instanceof Error && error.name === "AbortError"
        ? "The request took too long. Please try again."
        : "SafePlate could not reach the service. Check your connection and try again.",
    status: 0,
  });
}

export function displayError(error: unknown): string {
  if (error instanceof ApiError) {
    if (error.code === "job_enqueue_failed") {
      return "SafePlate could not queue the background work. Try again shortly; if it keeps happening, ask an Admin to check the worker queue setup.";
    }
    return error.message;
  }

  return "Something went wrong. Please try again.";
}
